import React, { useMemo, useState } from "react";
import { trackEvent } from "../../analytics";
import { ANALYTICS } from "../../lib/analyticsEvents";
import { buildErsteHaushalteShareMessage } from "../../lib/shareKiTaWin";
import "../SchoolEmailSetupCard/SchoolEmailSetupCard.css";

/**
 * Admin-only: copy Erste Haushalte message + link for WhatsApp / chat paste.
 */
export default function AdminErsteHaushalteLinkCard() {
  const [copied, setCopied] = useState(false);
  const message = useMemo(
    () => buildErsteHaushalteShareMessage({ utmSource: "admin" }),
    [],
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(message);
      setCopied(true);
      trackEvent(ANALYTICS.erste_haushalte_link_copied, {
        surface: "mehr",
        kind: "message",
      });
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section className="school-email-setup" aria-labelledby="erste-haushalte-link-title">
      <div className="mehr-list-title-row">
        <h3 id="erste-haushalte-link-title" className="school-email-setup-title">
          Erste Haushalte teilen
        </h3>
        <span className="mehr-list-admin-badge">Admin</span>
      </div>
      <p className="school-email-setup-hint">
        Eine Schaltfläche kopiert Nachricht + Link — bereit für WhatsApp oder andere Chats.
        Antworten landen in Supabase (<code>erste_haushalte_responses</code>) und GA4 (
        <code>erste_haushalte_tap</code>).
      </p>
      <pre className="school-email-setup-address school-email-setup-message">{message}</pre>
      <div className="school-email-setup-row">
        <button type="button" className="school-email-setup-btn" onClick={handleCopy}>
          {copied ? "Kopiert — bereit zum Einfügen" : "Nachricht + Link kopieren"}
        </button>
      </div>
    </section>
  );
}
